/** The OpenReplay assist protocol events (tracker-assist 6.0.0) the Live View plugin sends or handles. */
export enum OpenReplayAssistSocketEvent {
    MESSAGES = 'messages',
    UPDATE_SESSION = 'UPDATE_SESSION',
    NEW_AGENT = 'NEW_AGENT',
    AGENTS_CONNECTED = 'AGENTS_CONNECTED',
    AGENT_DISCONNECTED = 'AGENT_DISCONNECTED',
    NO_AGENT = 'NO_AGENT',
}
